<template>
  <!--Single Player Actions-->
  <div class="action" v-if="!multiple">
    <template v-if="$parent.player[signatureId]">
      <!--Draw Angle-->
      <button :class="{'disabled': !$parent.isCheckedAnglePoint(signatureId)}" @click="$parent.drawDimension(signatureId)" v-tooltip :title="trans('Uzaklığı Göster')" data-placement="right"><i class="fas fa-ruler-triangle"></i></button>
      <button :class="{'disabled': !$parent.isCheckedAnglePoint(signatureId)}" @click="$parent.drawAngle(signatureId)" v-tooltip :title="trans('Açıyı Göster')" data-placement="right"><i class="fas fa-drafting-compass"></i></button>

      <!--Play Actions-->
      <button @click="$parent.playerPlay(signatureId)" v-if="!$parent.player[signatureId].play" v-tooltip :title="trans('Oynat')" data-placement="right"><i class="fas fa-play"></i></button>
      <button @click="$parent.playerPause(signatureId)" v-else v-tooltip :title="trans('Duraklat')" class="active" data-placement="right"><i class="fas fa-pause"></i></button>
      <button @click="$parent.playerRepeat(signatureId, false); $parent.playerStop(signatureId)" v-tooltip :title="trans('Durdur')" data-placement="right"><i class="fas fa-stop"></i></button>

      <button @click="$parent.playerRepeat(signatureId)" v-tooltip :title="trans('Tekrarla')" data-placement="right" :class="{'active': $parent.player[signatureId].repeat}"><i class="fas fa-repeat"></i></button>
      <button @click="$parent.playerVelocity(signatureId, true)" v-tooltip data-container="#signature" :key="$parent.player[signatureId].velocityFactor + 'y'" :title="trans('Hızlandır') + ' (' + $parent.player[signatureId].velocityFactor + ')'" data-placement="right" :class="{'active': $parent.player[signatureId].velocityFactor > 1}"><i class="fas fa-fast-forward"></i></button>
      <button @click="$parent.playerVelocity(signatureId, false)" v-tooltip data-container="#signature" :key="$parent.player[signatureId].velocityFactor + 'x'" :title="trans('Yavaşlat') + ' (' + $parent.player[signatureId].velocityFactor + ')'" data-placement="right" :class="{'active': $parent.player[signatureId].velocityFactor < 1}"><i class="fas fa-fast-backward"></i></button>
    </template>
  </div>

  <!--Multiple Player Actions-->
  <div class="action multiple" v-else>
    <button @click="playerPlayAll()" v-tooltip :title="trans('Tümünü Oynat')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-play"></i></button>
    <button @click="playerPauseAll()" v-tooltip :title="trans('Tümünü Duraklat')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-pause"></i></button>
    <button @click="playerStopAll()" v-tooltip :title="trans('Tümünü Durdur')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-stop"></i></button>

    <button @click="playerRepeatAll()" v-tooltip :title="trans('Tümünü Tekrarla')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-repeat"></i></button>
    <button @click="playerVelocityAll(true)" v-tooltip data-container="#signature" :title="trans('Tümünü Hızlandır')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-fast-forward"></i></button>
    <button @click="playerVelocityAll(false)" v-tooltip data-container="#signature" :title="trans('Tümünü Yavaşlat')" data-placement="bottom" :class="{'disabled': !$parent.selected.length}"><i class="fas fa-fast-backward"></i></button>
  </div>
</template>

<script>
export default {
  name: 'SignatureActions',
  props: ['signatureId', 'multiple'],
  computed: {
      signatures() {
        return this.$parent.$refs.signature
      }
  },
  methods: {
    playerPlayAll() {
      Object.entries(this.signatures.player).forEach(([key, value]) => {
        this.signatures.playerPlay(key);
      });
    },
    playerPauseAll() {
      Object.entries(this.signatures.player).forEach(([key, value]) => {
        this.signatures.playerPause(key);
      });
    },
    playerStopAll() {
      Object.entries(this.signatures.player).forEach(([key, value]) => {
        this.signatures.playerRepeat(key, false);
        this.signatures.playerStop(key);
      });
    },
    playerRepeatAll() {
      Object.entries(this.signatures.player).forEach(([key, value]) => {
        this.signatures.playerRepeat(key);
      });
    },
    playerVelocityAll(increase) {
      Object.entries(this.signatures.player).forEach(([key, value]) => {
        this.signatures.playerVelocity(key, increase);
      });
    },
  }
}
</script>

<style lang="scss">
button.disabled{
  pointer-events: none;
  opacity: .65;
}

.action {
  button {
    border: none;
    padding: .25rem;
    background: #535d65;
    transition: 0.15s all;
    color: #FFF;
    display: inline-flex;
    border-radius: 2px;
    outline: none;
    align-items: center;
    justify-content: center;
    width: 23px;
    margin-bottom: 0.25rem;

    &:hover:not([disabled]), &.active {
      background: #48c774;
      cursor: pointer;
    }

    &:disabled {
      cursor: default;
      opacity: .65;
    }
  }
}

.action.multiple {
  gap: 5px;
  margin-right: 1rem;
  button {
    margin-bottom: 0;
  }
}
</style>
